<script>
	import { onMount } from 'svelte';
	import { doFetch } from '../../utils/Fetching.js';
	import { api_host, domain_code_store } from '../../stores.js';
	import { toast } from '@zerodevx/svelte-toast';


    export let params = {};
    let domain_code = '';
    domain_code_store.subscribe(value => {
        domain_code = value;
    });

	onMount(async () => {
		if (!(params.uid && params.token && params.userId)) {
            toast.push('Invalid activation code', {
                duration: 3000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
		}
		const res = await doFetch(
            `${api_host}/auth/activate`,
            'POST',
            {
                uid: params.uid,
                activateToken: params.token,
                userId: params.userId
            },
            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );
		if (res.msg == 'Successfully activated') {
            toast.push(res.msg, {
                duration: 3000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#48BB78',
                    '--toastProgressBackground': '#2F855A'
                }
            });
			window.location.href = '/#/login';
		} else {
            toast.push(res.msg || 'Activation failed', {
                duration: 3000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
		}
	});
</script>

<div style="width: 100%;height: 100%;text-align: center;margin-top: 30px;">
	<h1>Activating...</h1>
</div>